import * as React from 'react'

import * as styles from './itemThumbnailCarousel.module.css'

const ItemThumbnailCarousel = ({
  children,
  justifyContent,
  itemWidth = 'auto'
}: {
  children: any
  justifyContent?: 'center'
  itemWidth?: number | 'auto'
}) => {
  return (
    <div className={styles.itemListWrapper}>
      <ul className={styles.itemListContainer} style={{ justifyContent }}>
        {React.Children.map(children, child => {
          return (
            <li className={styles.itemList} style={{ width: itemWidth }}>
              {child}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default ItemThumbnailCarousel
